import React, { Fragment, useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import { css, StyleSheet } from 'aphrodite';
import Grid from '@material-ui/core/Grid';
import moment from 'moment';
import { Tooltip } from '@material-ui/core';
import { Doughnut } from 'react-chartjs-2';
import { Helper } from '../../common/helpers/Helper';
import { BaseEntityPage } from '../../common/components/BaseEntityPage';
import { Stats } from '../../components/Stats';
import { AppUiHelper } from '../../helpers/AppUiHelper';
import { AppStyles, AppTheme } from '../../styles/AppTheme';
import { ReportFilterBar } from '../../common/components/charts/ReportFilterBar';
import { GraphDialog } from '../../common/components/charts/GraphDialog';
import { GraphHelper } from '../../common/components/charts/GraphHelper';
import { AppHelper } from '../../helpers/AppHelper';
import { GraphUiHelper } from '../../helpers/GraphUiHelper';
import { VenueSummary } from '../../components/VenueSummary';
import { ApiHelper } from '../../common/helpers/ApiHelper';
import { DP_DISPLAY_NAME_MAP } from '../../data/data';

export class DevicesActivity extends BaseEntityPage {
  pageKey = 'DevicesActivity';
  pageTitle = this.options.pageForOrgType === 'PARTNER' ? Helper.getString('partnerExchangeReports') : Helper.getString('exchangeReports');
  orgId = this.props.match.params.orgId || 'PRODUCT';
  breadCrumbs = [
    { title: Helper.getString('home'), to: this.baseRoute() },
    { title: Helper.getString('exchangeReports') },
  ];
  noAdd = true;
  state = {
    dateTs: moment().subtract(1, 'day').format('YYYY-MM-DD'),
    stats: [],
    items: [],
  };

  constructor(props, options) {
    super(props, options);
    this.chartOptions = GraphHelper.getdoughnutChartOptions()
    this.lineChartOptions = GraphHelper.getLineChartOptions()
    this.noTableHead = true
    this.sitesById = {}
    if(options.exchangeReportsTrimmed) {
      this.pageTitle = Helper.getString('partnerAdApiExchangeReports')
    }
    this.tableHeadersMap = {
      Index: (current) => {
        return (
          <span className={css(Styles.indexStyle)}>{current.__index + 1}</span>
        )
      },
      Venue: (current) => {
        const site = current.site || current.siteInfo || (current.orgId && this.sitesById[current.orgId])
        return (
          <div className={css(Styles.venueColumn)}>
            <VenueSummary item={current} site={site} showNotRegistered={false}  />
            <span>First Online at: {Helper.formatDate2({ utcTimestamp: current.hf, format: 'hh:mm a' })}</span>
            <div>
              {current.noOfhrsOnline && current.noOfhrsOnline > 0 ? AppUiHelper.chipGreen('ONLINE: ' + current.noOfhrsOnline + '/24 hours') : AppHelper.offlineStatus()}
            </div>
          </div>
        )
      },
      Info: (current) => {
        if (this.options.exchangeReportsTrimmed) {

          let totalLeased = 0
          let totalPop = 0
          let totalServed = 0

          Object.keys(current).forEach(key => {

            if (key.startsWith('totalAds')) {
              totalLeased += current[key] || 0
            }

            if (key.startsWith('totalPop')) {
              totalPop += current[key] || 0
            }
            if (key.startsWith('totalSvd')) {
              totalServed += current[key] || 0
            }

          })

          return (
            <div className={css(Styles.statsContainer)}>

              <div className={css(Styles.statsInnerContainer)}>
                <span className={css(Styles.dpText)}>Programmatic Lease</span>
                <span className={css(Styles.statsValueText)}>
                  {AppHelper.formatNumberStats(totalLeased)}
                </span>
              </div>

              <div className={css(Styles.statsInnerContainer)}>
                <span className={css(Styles.dpText)}>Programmatic Serve</span>
                <span className={css(Styles.statsValueText)}>
                  {AppHelper.formatNumberStats(totalServed)}
                </span>
              </div>

              <div className={css(Styles.statsInnerContainer)}>
                <span className={css(Styles.dpText)}>Programmatic Pop</span>
                <span className={css(Styles.statsValueText)}>
                  {AppHelper.formatNumberStats(totalPop)}
                </span>
              </div>

              <div className={css(Styles.statsInnerContainer)}>
                <span className={css(Styles.dpText)}>Ad API Reqs</span>
                <span className={css(Styles.statsValueText)}>
                  {AppHelper.formatNumberStats(current.totalAdApiReqs || 0)}
                </span>
              </div>

              <div className={css(Styles.statsInnerContainer)}>
                <span className={css(Styles.dpText)}>CMS Pop</span>
                <span className={css(Styles.statsValueText)}>
                  {AppHelper.formatNumberStats(current.totalCmsPop || 0)}
                </span>
              </div>

            </div>
          )
        }

        return (
          GraphUiHelper.getExchangesOverallData(current, { showSvd: this._isDefHoldOrg()})
        )
      }
    }
    this.tableHeaders = Object.keys(this.tableHeadersMap);
    this.toFetch = this.makeFetches();
    this.toFetch.push({ method: 'GET', endPoint: ApiHelper.makeUrlPath(['orgs', this.orgId]) })
    if (options.exchangeReportsTrimmed) {
      this.headerActions = [
        {
          label: Helper.getString('download'),
          onClick: () => this.exportReports({ reportType: 'partner' })
        },
      ]

    } else {
      this.headerActions = [
        {
          label: Helper.getString('partnerReport'),
          onClick: () => this.exportReports({ reportType: 'partner' })
        },
        {
          label: Helper.getString('internalReport'),
          onClick: () => this.exportReports({ reportType: 'internal' })
        },
      ]
    }

  }

  exportReports = ({ reportType }) => {
    const prefixes = ['get_', 'ads_', 'pop_', 'err_', 'latestStrErr_'];
    if(this._isDefHoldOrg()) prefixes.push('svd_')
    // eslint-disable-next-line no-undef
    const exchangesSet = new Set();
    // eslint-disable-next-line no-undef
    const metricKeysSet = new Set();
    // Loop through all items and collect keys
    this.state.items.forEach(item => {
      Object.keys(item).forEach(key => {
        if (prefixes.some(p => key.startsWith(p))) {
          metricKeysSet.add(key)
          exchangesSet.add(key.split('_')[1])
        }
      });
    });
    const exchanges = [...exchangesSet]
    const metricKeys = [...metricKeysSet]
    if (reportType === 'internal') {
      const headers = {
        deviceTitle: 'deviceTitle',
        deviceCode: 'deviceCode',
        _ADDRESS: 'address',
        'site.title': 'siteTitle',
        'site.address': 'siteAddress',
        serialNumber: 'serialNumber',
        hf: 'firstOnlineAt',
        noOfhrsOnline: 'noOfhrsOnline',
        cmsPop: 'cmsPop',
        adapireqs: 'adapireqs',
      }
      for (const ex of exchanges) {
        for (const prefix of prefixes) {
          if (metricKeys.includes(prefix + ex))
            headers[prefix + ex] = prefix === 'ads_' ? 'lsd_' + ex : prefix + ex
        }
      }
      this.customExport = {
        buttonTitle: Helper.getString('internalReport'),
        headers: headers,
        format: 'xlsx'
      }
      this.setState({
        dataToDownload: this.state.items
      }, () => {
        this.onExport({ reportType })
      })
    } else if (reportType === 'partner' && !this.options.exchangeReportsTrimmed) {
      const headers = {
        deviceTitle: 'deviceTitle',
        deviceCode: 'deviceCode',
        _ADDRESS: 'address',
        noOfhrsOnline: 'onlineHours',
        adapireqs: 'adApiReqs',
        cmsPop: 'cmsPop',
        programmaticLease: 'programmaticLease',
      }
      if(this._isDefHoldOrg()) headers.programmaticServed = 'programmaticServe'
      headers.programmaticPop = 'programmaticPop'
      for (const item of this.state.items) {
        let getExchange = 0
        let popExchange = 0
        let programmaticServed = 0
        for (const ex of exchanges) {
          getExchange = getExchange + (item['ads_' + ex] || 0)
          popExchange = popExchange + (item['pop_' + ex] || 0)
          programmaticServed  = programmaticServed + (item['svd_' + ex] || 0)
        }
        item.programmaticLease = getExchange
        item.programmaticPop = popExchange
        item.programmaticServed = programmaticServed
      }
      this.customExport = {
        buttonTitle: Helper.getString('partnerReport'),
        headers: headers,
        format: 'xlsx'
      }
      this.setState({
        dataToDownload: this.state.items
      }, () => {
        this.onExport({ reportType })
      })
    } else if (reportType === 'partner' && this.options.exchangeReportsTrimmed) {
      const headers = {
        deviceTitle: 'deviceTitle',
        deviceCode: 'deviceCode',
        _ADDRESS: 'address',
        noOfhrsOnline: 'onlineHours',
        totalAdApiReqs: 'adApiReqs',
        totalCmsPop: 'cmsPop',
        totalAds: 'programmaticLease',
      }
      if(this._isDefHoldOrg()) headers.totalSvd = 'programmaticServe'
      headers.totalPop = 'programmaticPop'
      this.customExport = {
        buttonTitle: Helper.getString('partnerReport'),
        headers: headers,
        format: 'xlsx'
      }
      this.setState({
        dataToDownload: this.state.items
      }, () => {
        this.onExport({ reportType })
      })
    }
  }

  onExport({ reportType }) {
    if (this.customExport && this.customExport.format === 'xlsx') {
      const DwnldUtil = require('../../common/helpers/FileDownloader');

      const fileName = this.makeFileName({ reportType });
      const rows = this.prepExcelDownload()
      DwnldUtil.FileDownloader.exportAsExcelFile(rows, fileName)
    }
  }

  prepExcelDownload() {
    const rows = [];

    for (const item of this.state.dataToDownload) {
      const e = {};
      for (const hKey in this.customExport.headers) {
        e[this.customExport.headers[hKey]] = this.exportRowItemValue(hKey, item)
      }
      rows.push(e);
    }
    return rows
  }

  exportRowItemValue(key, current) {
    const serialNumber = current.latestDeviceFeed && current.latestDeviceFeed.serialnumber
      ? current.latestDeviceFeed.serialnumber
      : current.serialNumber
    const site = current.site || current.siteInfo || (current.orgId && this.sitesById[current.orgId]) || {}

    switch (key) {
    case 'site.title':
      return site.title || ''
    case 'site.address':
      return site.address || ''
    case 'serialNumber':
      return serialNumber || ''
    case 'hf':
      return current.hf ? Helper.formatDate2({ utcTimestamp: current.hf, format: 'hh:mm a' }) : ''
    default:
      return super.exportRowItemValue(key, current)
    }
  }


  makeFetches = () => {
    const { dateTs } = this.state;
    const queryParams = {}
    if (dateTs) queryParams.period = dateTs.replaceAll('-', '')
    queryParams.groupId = this.orgId
    if(this.options.exchangeReportsTrimmed) queryParams.trim = 'YES'
    return [{ method: 'GET', paths: ['miscs', 'deviceactivity'], queryParams }];
  };

  onFetchSuccess = (results) => {

    // Stats ------
    const org = results[1] || this.state.org
    const statusInfo = AppUiHelper.getDaStatsInfo()
    if (org && org.features && (org.features.includes('AD_DEF_HOLD') || org.features.includes('AD_DEF_APPROVED') && this.options.exchangeReportsTrimmed)) {
      statusInfo.totalSvd = {
        title: 'Served Ads',
        image: require('../../assets/icons/partner-reports/served.svg'),
        order: '3.5'
      }
    }
    const pStats = []
    pStats.push({
      title: statusInfo.totalVenues.title,
      value: results[0].items.length,
      image: statusInfo.totalVenues.image,
      order: statusInfo.totalVenues.order
    })
    for (const [key, value] of Object.entries(results[0].stats)) {
      if (!statusInfo[key]) continue
      let title = statusInfo[key].title

      if (this.options.exchangeReportsTrimmed) {

        if (title === 'Errors') continue
        if (title === 'Exchange Get Ads') continue

        if (title === 'Served Ads') {
          title = 'Programmatic Serve'
        }

        if (title === 'PoPs') {
          title = 'Programmatic Pop'
        }

        if (title === 'Leased Ads') {
          title = 'Programmatic Lease'
        }

        if (title === 'Dolphin Ad API Calls') {
          title = 'Ad API Reqs'
        }
      }
      pStats.push({
        title,
        value: AppHelper.formatNumberStats(value || 0),
        image: statusInfo[key].image,
        order: statusInfo[key].order
      })
    }
    const pResult = this.processData(results[0])
    this.sitesById = results[0].sitesById || {}
    pResult.items.forEach(item => {
      if (item.orgId && this.sitesById[item.orgId]) item.siteInfo = { ...this.sitesById[item.orgId] }
    })
    const processedItems = AppHelper.processVenueItemsFromDa(pResult.items)
    console.log('results[1]', results[1])
    this.setState({
      stats: Helper.sortDictArray(pStats),
      items: processedItems,
      dpChartsData: pResult.dpChartsData,
      org: results[1] || this.state.org
    });
  };

  processData = (result) => {
    const labels = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12', '13', '14', '15', '16', '17', '18', '19', '20', '21', '22', '23']
    const chartTitle = 'Heartbeat By Hour'
    for (const item of result.items) {
      item.hbGraphData = GraphHelper.generateLineGraphData({ chartTitle, labels, data: item.statusByHour })
    }
    result.dpChartsData = this.generateDataForDoughNutGraph(result)
    return result
  }

  _isDefHoldOrg() {
    return this.state.org && this.state.org.features && this.state.org.features.includes('AD_DEF_HOLD')
  }

  generateDataForDoughNutGraph(result) {
    const dp = {}
    for (const key in result.stats) {
      const splitArr = key.split('_')
      if (splitArr.length !== 2) continue
      if (!dp[splitArr[1]]) dp[splitArr[1]] = {}
      dp[splitArr[1]][key] = result.stats[key]
    }
    const dpChartsData = []
    for (const key in dp) {
      const chartTitle = DP_DISPLAY_NAME_MAP[key] || key
      const labelsWithoutCounter = ['POP', 'GET', 'LEASED', 'ERROR']
      if(this._isDefHoldOrg()) labelsWithoutCounter.push('SERVED')
      const data = []
      const labels = []
      for (const label of labelsWithoutCounter) {
        let value = 0;
        if (label === 'POP') data.push(dp[key]['totalPop_' + key] || 0), value = AppHelper.formatNumberStats(dp[key]['totalPop_' + key] || 0)
        if (label === 'GET') data.push(dp[key]['totalGet_' + key] || 0), value = AppHelper.formatNumberStats(dp[key]['totalGet_' + key] || 0)
        if (label === 'LEASED') data.push(dp[key]['totalAds_' + key] || 0), value = AppHelper.formatNumberStats(dp[key]['totalAds_' + key] || 0)
        if (label === 'SERVED' && this._isDefHoldOrg()) data.push(dp[key]['totalSvd_' + key] || 0), value = AppHelper.formatNumberStats(dp[key]['totalSvd_' + key] || 0)
        if (label === 'ERROR') data.push(dp[key]['totalErr_' + key] || 0), value = AppHelper.formatNumberStats(dp[key]['totalErr_' + key] || 0)
        labels.push(`${label} (${value})`)
      }
      let allZero = true
      for (const d of data) {
        if (d !== 0) {
          allZero = false
          break
        }
      }
      if (allZero) continue
      dpChartsData.push(GraphHelper.generateDoughNutGraphData({ chartTitle, labels, data }))
    }
    return dpChartsData
  }

  generateDataForDoughNutGraphForVenue(current) {
    const dp = {}
    const latestError = {}
    for (const key in current) {
      if (key.startsWith('latestErr_')) {
        const code = key.split('_')[1]
        latestError[code] = {
          code,
          error: current[key]
        }
      }
      const splitArr = key.split('_')
      if (splitArr.length !== 2) continue
      if (!dp[splitArr[1]]) dp[splitArr[1]] = {}
      dp[splitArr[1]][key] = current[key]
    }
    const dpChartsData = []
    for (const key in dp) {
      const chartTitle = DP_DISPLAY_NAME_MAP[key] || key
      const labelsWithoutCounter = ['POP', 'GET', 'LEASED', 'ERROR']
      if(this._isDefHoldOrg()) labelsWithoutCounter.push('SERVED')
      const data = []
      const labels = []
      for (const label of labelsWithoutCounter) {
        let value = 0;
        if (label === 'POP') data.push(dp[key]['pop_' + key] || 0), value = AppHelper.formatNumberStats(dp[key]['pop_' + key] || 0)
        if (label === 'GET') data.push(dp[key]['get_' + key] || 0), value = AppHelper.formatNumberStats(dp[key]['get_' + key] || 0)
        if (label === 'LEASED') data.push(dp[key]['ads_' + key] || 0), value = AppHelper.formatNumberStats(dp[key]['ads_' + key] || 0)
        if (label === 'SERVED' && this._isDefHoldOrg()) data.push(dp[key]['svd_' + key] || 0), value = AppHelper.formatNumberStats(dp[key]['svd_' + key] || 0)
        if (label === 'ERROR') data.push(dp[key]['err_' + key] || 0), value = AppHelper.formatNumberStats(dp[key]['err_' + key] || 0)
        labels.push(`${label} (${value})`)
      }

      let allZero = true
      for (const d of data) {
        if (d !== 0) {
          allZero = false
          break
        }
      }
      if (allZero) continue
      dpChartsData.push(GraphHelper.generateDoughNutGraphData({ chartTitle, labels, data, latestError }))
    }
    return dpChartsData
  }

  generateTableMap = (items = {}) => {
    const map = {};
    Object.keys(items).forEach((key) => {
      if (key !== 'id') {
        map[items[key]] = (current) => <div>{current[key]}</div>;
      }
    });
    return map;
  };

  onTableValue = (current, index) => {
    if (!this.tableHeaders[index]) return '';
    return this.tableHeadersMap[this.tableHeaders[index]](current);
  };

  onFilter = (filters) => {
    this.setState(
      filters,
      () => {
        this.toFetch = this.makeFetches();
        this.fetchItems();
      }
    );
  };

  makeFileName = ({ reportType }) => {
    const dateTs = this.state.dateTs.replaceAll('-', '')
    if (reportType === 'partner' && this.options.exchangeReportsTrimmed) {
      return `exchange-report-${this.orgId}-${dateTs}`
    } else if (reportType === 'partner') {
      return `external-report-${this.orgId}-${dateTs}`
    } else {
      return `dd-diagnostics-${this.orgId}-${dateTs}`
    }
  }

  renderAboveTable = () => {
    const { items, stats } = this.state;
    return (
      <div className={css(Styles.renderAboveTable)}>
        <ReportFilterBar
          buttonLabel={Helper.getString('filter')}
          onFilter={this.onFilter}
          dateTs={this.state.dateTs}
        />
        {stats && <Stats items={stats}></Stats>}
        {!this.options.exchangeReportsTrimmed && this.state.dpChartsData && this.state.dpChartsData.length > 0 &&
          <Grid className={css(Styles.chartsContainer)} container spacing={2}>
            {this.state.dpChartsData.map((x, index) => {
              if (!x.data.datasets[0].data || x.data.datasets[0].data.length === 0) return ''
              return (
                <Grid item key={'chart_' + index} className={css(Styles.eachChartHolder)} xs={12} md={4}>
                  <div className={css(Styles.chartOuterWrap)} >
                    <div className={css(Styles.chartBlock)} >
                      {x.chartTitle &&
                        <div className={css(Styles.chartTitle)}>{x.chartTitle}</div>
                      }
                      {x.hasDataMoreThanZero === false ?
                        <div className={css(Styles.noChartMessage)}>{Helper.getString('noChartDataMessage')}</div> :
                        <Doughnut className={css(Styles.chartCanvas)} data={x.data} options={this.chartOptions} width={100} height={100} />}
                    </div>
                  </div>
                </Grid>
              )
            })}
          </Grid>
        }
        {this.state.showVenueGraphs &&
          <GraphDialog
            isOpen={this.state.showVenueGraphs}
            lineChartData={this.state.current.hbGraphData}
            lineChartOptions={this.lineChartOptions}
            title={(this.state.current && this.state.current.deviceCode) ? this.state.current.deviceCode : Helper.getString('venueInfo')}
            onClosed={() => this.setState({ showVenueGraphs: false })}
            fullWidth={true}
            doughnutChartData={
              this.options.exchangeReportsTrimmed
                ? []
                : this.generateDataForDoughNutGraphForVenue(this.state.current)
            }
          />
        }
      </div>
    );
  };

  onActions = (current) => {
    const actions = []
    actions.push(
      <Tooltip title='Screen Ad Details' placement='top-start' key={current.id + 'Preview'}>
        <span className={css(AppStyles.entityTableLinkIcon)}>
          <img className={css(Styles.actionIconImage)} src={require('../../assets/icons/eye.svg')} onClick={() => { this.setState({ showVenueGraphs: true, current }) }} />
        </span>
      </Tooltip>
    )
    if(this.options.pageForOrgType === 'PARTNER' && !this.options.exchangeReportsTrimmed) {
      actions.push(
        <Link target='_blank' to={`/admin/partners/${this.orgId}/devices-activity/screens/${current.deviceId}`}
          key={current.id + '-org'}>
          <Tooltip title='Past 30 Days Screen Report' placement='top-start'>
            <span className={css(AppStyles.entityTableLinkIcon)}>
              <i className='material-icons-outlined'>arrow_outward</i>
            </span>
          </Tooltip>
        </Link>
      )
    }

    return actions
  }
}

const Styles = StyleSheet.create({
  statsContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: 5
  },
  statsInnerContainer: {
    display: 'flex',
    gap: 15,
    borderBottom: '1px solid #d7d7d7b5',
    padding: '5px 0px',
    width: 'max-content'
  },
  dpText: {
    fontWeight: 'bold',
    backgroundColor: '#f5f5f5',
    padding: '3px 6px',
    borderRadius: 4,
    minWidth: 20,
    textAlign: 'center'
  },
  statsValueText: {
    // fontWeight: 'bold',
    backgroundColor: '#f5f5f5',
    padding: '3px 6px',
    borderRadius: 4,
    minWidth: 20,
    textAlign: 'center'
  },
  statsValues: {
    display: 'flex',
    alignItems: 'center',
    gap: 10
  },
  venueColumn: {
    display: 'flex',
    gap: 7,
    flexDirection: 'column'
  },
  spanValue: {},
  img: {
    height: 30,
  },
  line2: {
    fontSize: 12,
  },
  renderAboveTable: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    gap: 10
  },
  circleFill: {
    width: 18,
    height: 18,
    borderRadius: '50%',
  },
  fullWidth: {
    width: '100%',
  },
  mainContainer: {
    backgroundColor: AppTheme.primaryBg,
    width: '100%',
    '@media (max-width: 1025px)': {
      width: '97vw !important'
    }
  },
  eachChartHolder: {
    // padding:0,
    // marginBottom:12
  },
  eachChartHolder2: {
    // padding:0,
    // marginBottom:12
    width: '100%'
  },
  chartsContainer: {
    marginTop: '5px 0px',
    margin: '15px 0px',
    width: '100%',
  },
  chartOuterWrap: {
    background: '#fff',
    height: 214,
    borderRadius: 16
  },
  chartOuterWrap2: {
    background: '#fff',
    borderRadius: 16
  },
  chartBlock: {
    borderRadius: 16,
    padding: '10px 10px 10px 10px',
    // background: '#fff',
    // marginRight:10,
    // overflow: 'hidden',
    height: 160
  },
  chartTitle: {
    fontSize: 16,
    color: '#121212',
    padding: 4
  },
  chartCanvas: {
    marginBottom: 10
  },
  statsHolder: {
    padding: '0 10px'
  },
  storeNameText: {
    fontWeight: 'bolder',
    fontSize: '16px',
    color: '#121212'
  },
  noChartMessage: {
    display: 'flex',
    justifyContent: 'center',
    height: '100%',
    flexDirection: 'column',
    textAlign: 'center'
  },
  addressSpan: {
    color: '#575757',
    fontWeight: 600
  }
});



// WEBPACK FOOTER //
// ./src/screens/admin/DevicesActivity.js